import { render, staticRenderFns } from "./MvdPositionSelection.vue?vue&type=template&id=31dfb543&"
import script from "./MvdPositionSelection.vue?vue&type=script&lang=ts&"
export * from "./MvdPositionSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports